import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item"];

  setActive(event) {
    const newActiveItem = this.itemTargets.find(item => item.dataset.path === event.params.path);

    this.itemTargets.forEach(item => {
      item.classList.remove("active");
    })

    newActiveItem.classList.add("active");
  }
}
